import React, { useRef, useState } from "react";
import { useDSATraceabilityController } from "./useDSATraceability.controller.js";
import { Button, Popover, Stack, Text } from "@bookingcom/bui-react";
import { QuestionMarkCircleIcon } from "@bookingcom/bui-assets-react/streamline";
export function DSATraceabilityPopover(props) {
    const { a11yClose, a11yTooltip, content, shouldRender, text, title } = useDSATraceabilityController(props);
    const ref = useRef(null);
    const [active, setActive] = useState(false);
    if (!shouldRender)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { gap: 2, mixin: { marginBlockEnd: 6 } },
            React.createElement(Stack, { attributes: { style: { display: "inline-flex" } }, gap: 0, direction: "row", alignItems: "center" },
                React.createElement(Stack.Item, null,
                    React.createElement(Text, { variant: "body_2" }, text)),
                React.createElement(Stack.Item, null,
                    React.createElement(Button, { ref: ref, attributes: { "aria-label": a11yTooltip }, icon: QuestionMarkCircleIcon, variant: "tertiary-neutral", onClick: () => setActive(true) })))),
        React.createElement(Popover, { position: "top-start", triggerRef: ref, closeAriaLabel: a11yClose, active: active, onClose: () => setActive(false), onAfterClose: () => setActive(false) },
            React.createElement(Popover.Content, { title: title },
                React.createElement(Stack, null, content.map((c) => (React.createElement(Stack.Item, { key: c },
                    React.createElement(Text, { variant: "body_2" }, c)))))))));
}
